import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const stack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
});

export const banner: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.25),
  bgcolor: { xs: "background.paper", md: "background.default" },
  borderRadius: 1.75,
  p: { xs: 1.25, md: 1.625 },
});

export const socialRow =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    bgcolor: active ? alpha(theme.palette.primary.main, 0.07) : "background.default",
    border: 1,
    borderColor: active ? "primary.main" : "transparent",
    borderRadius: 1.75,
    p: theme.spacing(1.25),
    transition: "all 0.2s ease",
  });

export const platformIcon =
  (color: string): SxProps<Theme> => ({
    width: { xs: 34, md: 38 },
    height: { xs: 34, md: 38 },
    borderRadius: 1.25,
    bgcolor: alpha(color, 0.1),
    color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "none",
  });

export const starButton =
  (enabled: boolean, active: boolean): SxProps<Theme> =>
  (theme) => ({
    cursor: enabled ? "pointer" : "default",
    flex: "none",
    p: 1,
    color: active ? theme.palette.secondary.main : theme.palette.text.secondary,
    opacity: enabled ? 1 : 0.35,
    transition: "all 0.2s ease",
  });

export const footerRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.75),
  borderTop: 1,
  borderColor: "divider",
  pt: 2.25,
});

export const savedFlash: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  fontSize: "0.75rem",
  color: "success.main",
  fontWeight: 600,
};
